// RoleUtils.ts


import { environment } from "../../../environments/environment";
import RolesEnum from "../enums/roles.enum";


// This utility class provides methods for role-based checks.
export class RoleUtils {
    static isAdminOrSuperUser(): boolean {
        return environment.roles.has(RolesEnum.ADMINISTRATOR) || environment.roles.has(RolesEnum.SUPER_USER);
    }

    static isSuperUser(): boolean {
        return environment.roles.has(RolesEnum.SUPER_USER);
    }
}

// Export the method as a standalone function (similar to Java's static import)
export const isAdminOrSuperUser = RoleUtils.isAdminOrSuperUser;
export const isSuperUser = RoleUtils.isSuperUser;